import { createBrowserHistory } from 'history'

import changeSet from 'core/change_set'

export const createBlockingHistory = () => {
  const history = createBrowserHistory({
    getUserConfirmation: changeSet.confirmNavigation
  })

  history.block(changeSet.shouldBlockNavigation)

  return history
}
